<template>
  <div>
    <article class="fresh-characteristic clearfix">
      <div class="characteristic-top">
        <h3>传统生鲜行业特点</h3>
        <span></span>
      </div>
      <span class="characteristic-text">
        传统生鲜行业存在产品零散，季节性限制等情况
      </span>
      <div class="characteristic-content clearfix">
        <div class="content" v-for="list in productList" :key="list.id">
          <div class="content-top">
            <img :src="list.img" />
          </div>
          <div class="content-center">
            <span class="desc">{{ list.desc }}</span>
          </div>
        </div>
      </div>
    </article>
    <article class="fresh-pain clearfix">
      <div class="pain-top">
        <h3>生鲜电商的痛点</h3>
        <span></span>
      </div>
      <span class="pain-text">
        生鲜电商平台的痛点是我们做出解决方案的前提
      </span>
      <div class="pain-content">
        <address class="content-top">
          <div class="top-left">
            <div class="text">
              生鲜电商市场虽然火爆，但是没有一个成熟的模式，针对生鲜类产品,人们还未养成线上购买的习惯
              
            </div>
            <div class="img">大环境不成熟</div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
          <div class="top-right">
            <div class="text">
              如果产品与农贸市场与超市无异，势必没有竞争力，在现在的大环境下，生鲜产品市场的检测水平和机制堪忧
            </div>
            <div class="img">产品质量控制</div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
        </address>
        <address class="content-bottom">
          <div class="bottom-left">
            <div class="img">营销问题</div>
            <div class="text">
              在复杂多变的市场环境中，你和消费者谈生鲜，第一反应是本能地怀疑
            </div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
          <div class="bottom-right">
            <div class="img">物流配送</div>
            <div class="text">
              在偌大的都市里送菜，成本压力巨大。看起来，产品毛利够高，但运作到后面还是亏本
            </div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
        </address>
      </div>
    </article>
    <article class="fresh-value clearfix">
      <div class="value-top">
        <h3>核心价值</h3>
        <span></span>
      </div>
      <span class="value-text">
        缩短供应链，让闭环内协作更加流畅
      </span>
      <div class="value-content">
        <address class="content-item">
          <img src="../../static/images/fresh/1.png" />
          <div class="item-span">
            <h3>砍掉中间环节，缩短供应链</h3>
            <h4>
              消费者可以先上商城预定自己想要的商品，以需定产，双向透明的运营模式，合理降低成本
            </h4>
          </div>
        </address>
        <address class="content-item">
          <img src="../../static/images/fresh/2.png" />
          <div class="item-span">
            <h3>丰富产品的选择，全渠道融合</h3>
            <h4>
              一般的生鲜蔬果店，由于占地面积有限，只能摆放几十种产品，通过远丰商城系统可以不限数量
            </h4>
          </div>
        </address>
        <address class="content-item">
          <img src="../../static/images/fresh/3.png" />
          <div class="item-span">
            <h3>结合分销，快速推广</h3>
            <h4>
              生鲜商城含有一套分销系统，会员可在线上一分钟开启分销二级店铺，分享至好友圈，快速分销
            </h4>
          </div>
        </address>
        <address class="content-item">
          <img src="../../static/images/fresh/4.png" />
          <div class="item-span">
            <h3>基于用户、消费者大数据的精准营销</h3>
            <h4>
              通过商城的大数据分析，预测消费者需求，使用商城后台多种促销手段吸引消费者购买
            </h4>
          </div>
        </address>
        <address class="content-item">
          <img src="../../static/images/fresh/5.png" />
          <div class="item-span">
            <h3>在线商城线上线下协作</h3>
            <h4>
              线上线下数据打通，通过生鲜品牌商城让客户（会员）成为公司的资产，线下实体店获取客户信息进行引导销售，目标客户群发送指定门店的促销信息
            </h4>
          </div>
        </address>
        <address class="content-item">
          <img src="../../static/images/fresh/6.png" />
          <div class="item-span">
            <h3>无缝对接、一体化管理</h3>
            <h4>
              通过ERP、门店POS对接、电商平台的一体化管理，同时把控门店、会员、供应链以及线上电商业务，实现标准化、低成本、高效率
            </h4>
          </div>
        </address>
      </div>
    </article>
    <article class="fresh-system clearfix">
      <div class="system-top">
        <h3>生鲜电商运营体系</h3>
        <span></span>
      </div>
      <span class="system-text">
        将多方资源进行有效结合，打通整条行业供应链
      </span>
      <div class="system-content">
        <img src="../../static/images/fresh/yytx.png" />
      </div>
    </article>
    <article class="fresh-function clearfix">
      <div class="function-top">
        <h3>六大系统功能</h3>
        <span></span>
      </div>
      <span class="function-text">
        多样化功能满足不同使用者不同要求
      </span>
      <div class="function-content">
        <div class="content-item">
          <address class="content-top">
            <img src="../../static/images/fresh/01.png" />
            <h4>
              每日订单自动汇总，采购单一键打印分拣、打包、出库统统一键搞定
            </h4>
          </address>
          <address class="content-bottom">
            <h3>01</h3>
            <img src="../../static/images/fresh/jt.png" />
            <h3>订单处理</h3>
          </address>
        </div>
        <div class="content-item">
          <address class="content-bottom">
            <h3>02</h3>
            <img src="../../static/images/fresh/jt.png" />
            <h3>利润报表</h3>
          </address>
          <address class="content-top">
            <img src="../../static/images/fresh/02.png" />
            <h4>
              明细易懂的方式展示出利润报表，让你一目了然
            </h4>
          </address>
        </div>
        <div class="content-item">
          <address class="content-top">
            <img src="../../static/images/fresh/03.png" />
            <h4>
              入库、出库、损耗管理、备货预警，让你放心操作，数据实现网络化
            </h4>
          </address>
          <address class="content-bottom">
            <h3>03</h3>
            <img src="../../static/images/fresh/jt.png" />
            <h3>库存处理</h3>
          </address>
        </div>
        <div class="content-item">
          <address class="content-bottom">
            <h3>04</h3>
            <img src="../../static/images/fresh/jt.png" />
            <h3>商品管理</h3>
          </address>
          <address class="content-top">
            <img src="../../static/images/fresh/04.png" />
            <h4>
              商品线上线下同价，智能计算配送费用，轻松管理定价
            </h4>
          </address>
        </div>
        <div class="content-item">
          <address class="content-top">
            <img src="../../static/images/fresh/05.png" />
            <h4>
              每日财务详情报表，日均流水，商品种类流水明细，让你轻松把握爆款商品
            </h4>
          </address>
          <address class="content-bottom">
            <h3>05</h3>
            <img src="../../static/images/fresh/jt.png" />
            <h3>财务管理</h3>
          </address>
        </div>
        <div class="content-item">
          <address class="content-bottom">
            <h3>06</h3>
            <img src="../../static/images/fresh/jt.png" />
            <h3>智能分拣称重</h3>
          </address>
          <address class="content-top">
            <img src="../../static/images/fresh/06.png" />
            <h4>
              智能秤流水作业，称重数据自动回传至系统无需人工操作，不易出错
            </h4>
          </address>
        </div>
      </div>
    </article>
  </div>
</template>
<script>
export default {
  name: "fresh",
  data() {
    return {
      productList: [
        {
          id: 0,
          img: require("../../static/images/fresh/ps.png"),
          desc: "配送时效性高",
        },
        {
          id: 1,
          img: require("../../static/images/fresh/qy.png"),
          desc: "区域化销售",
        },
        {
          id: 2,
          img: require("../../static/images/fresh/cp.png"),
          desc: "产品零散",
        },
        {
          id: 3,
          img: require("../../static/images/fresh/gcf.png"),
          desc: "高重复产品购买率",
        },
        {
          id: 4,
          img: require("../../static/images/fresh/jjx.png"),
          desc: "季节性限制",
        }
      ],
    }
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    }
  }
}
</script>
<style lang="stylus" scoped>
div {
  color: #333333;
}

.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.fresh-characteristic {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .characteristic-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .characteristic-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .characteristic-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .characteristic-content {
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 34px;

    .content {
      width: 256px;
      height: 256px;
      float: left;
      margin-left: 30px;
      margin-top: 24px;
      box-sizing: border-box;
      border: 1px solid #F5F5F5;

      .content-top {
        margin-top: 68px;
      }

      .content-center {
        font-size: 18px;
        margin-top: 27px;
        font-weight: bold;
      }
    }

    .content:hover {
      transform: scale(1.05, 1.05);
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    }

    .content:first-child {
      margin-left: 0;
    }
  }
}

.fresh-pain {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .pain-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .pain-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .pain-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .pain-content {
    width: 1400px;
    margin-top: 60px;

    .content-top {
      height: 206px;
      position: relative;
      border-bottom: 1px solid #F4F4F4;

      .text {
        padding: 22px 25px;
        width: 100%;
        height: 130px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: left;
      }

      .img {
        width: 100%;
        height: 48px;
        font-size: 18px;
        font-weight: bold;
        line-height: 40px;
        background-image: url('../../static/images/fresh/ds.png');
      }

      .b-yuan {
        position: absolute;
        top: 196px;
        left: 205px;
        width: 20px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 50%;
        box-sizing: border-box;
        padding: 5px;

        .s-yuan {
          width: 10px;
          height: 10px;
          background: #CCCCCC;
          border-radius: 50%;
        }
      }

      .top-left, .top-right {
        width: 270px;
        height: 170px;
        float: left;
        margin-left: 80px;
        background: #FFFFFF;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 7px;
      }

      .top-right {
        margin-left: 377px;

        .text {
          padding: 22px 20px;
        }

        .b-yuan {
          left: 852px;
        }
      }

      .top-left:hover, .top-right:hover {
        .img {
          background-image: url('../../static/images/fresh/dsh.png');
        }

        .b-yuan {
          background: #FFF9E5;

          .s-yuan {
            background: #FFC000;
          }
        }
      }
    }

    .content-bottom {
      height: 206px;
      position: relative;

      .text {
        padding: 73px 20px;
        width: 100%;
        height: 130px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: left;
      }

      .img {
        position: absolute;
        top: 22px;
        width: 270px;
        height: 48px;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        background-image: url('../../static/images/fresh/sds.png');
      }

      .b-yuan {
        position: absolute;
        top: -10px;
        left: 528px;
        width: 20px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 50%;
        box-sizing: border-box;
        padding: 5px;

        .s-yuan {
          width: 10px;
          height: 10px;
          background: #CCCCCC;
          border-radius: 50%;
        }
      }

      .bottom-left, .bottom-right {
        width: 270px;
        height: 170px;
        float: left;
        margin-left: 403px;
        margin-top: 29px;
        background: #FFFFFF;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 7px;
      }

      .bottom-right {
        margin-left: 377px;

        .text {
          padding: 63px 22px;
        }

        .b-yuan {
          left: 1175px;
        }
      }

      .bottom-left:hover, .bottom-right:hover {
        .img {
          background-image: url('../../static/images/fresh/sh.png');
        }

        .b-yuan {
          background: #FFF9E5;

          .s-yuan {
            background: #FFC000;
          }
        }
      }
    }
  }
}

.fresh-value {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .value-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .value-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .value-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .value-content {
    width: 1400px;
    height: 240px;
    margin-top: 60px;

    .content-item {
      float: left;
      width: 700px;
      height: 160px;
      border-radius: 4px;
      box-sizing: border-box;

      img {
        float: left;
        margin: 55px 63px 55px 75px;
      }

      .item-span {
        width: 470px;
        float: left;
        text-align: left;

        h3 {
          font-size: 18px;
          font-weight: bold;
          font-size: 18px;
          margin-top: 40px;
          margin-bottom: 13px;
        }

        h4 {
          float: left;
          font-size: 14px;
          line-height: 28px;
        }
      }
    }

    .content-item:nth-child(1), .content-item:nth-child(2), .content-item:nth-child(3), .content-item:nth-child(4) {
      border-bottom: 1px solid #F9F9F9;
    }

    .content-item:nth-child(2n-1) {
      border-right: 1px solid #F9F9F9;
    }

    .content-item:hover {
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
    }
  }
}

.fresh-system {
  width: 1400px;
  margin: 0 auto;
  text-align: center;

  .system-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .system-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .system-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .system-content {
    margin-top: 57px;
  }
}

.fresh-function {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .function-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .function-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .function-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .function-content {
    width: 1400px;
    height: 444px;
    margin-top: 60px;

    .content-item {
      width: 233px;
      height: 444px;
      float: left;

      .content-top {
        height: 300px;
        background: #FFFFFF;
        box-shadow: 0px 10px 25px 1px rgba(185, 185, 185, 0.15);

        img {
          margin: 60px 85px 45px 86px;
        }

        h4 {
          padding: 0 39px;
          font-size: 14px;
          line-height: 28px;
        }
      }

      .content-bottom {
        height: 144px;

        h3 {
          font-weight: bold;
          font-size: 18px;
          margin-top: 35px;
        }

        h3:last-child {
          margin-top: 7px;
        }
      }
    }

    .content-top:hover {
      transform: translateY(-10px);
    }
  }
}

.fresh-footer {
  width: 100%;
  height: 160px;
  margin-top: 161px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 28px;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 170px;
    height: 50px;
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 50px;
    border: 1px solid #FFFEFC;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/solutionFresh.vue